export default __webpack_public_path__ + "static/media/ic_luxembourg.e4eb45dd.svg";